import { on } from '@ember/modifier';
import { service } from '@ember/service';
import { t } from 'ember-intl';
import Component from '@glimmer/component';
import TextInput from 'ember-simplepractice/components/spds/input/text';
import styles from './contact-search.module.scss';
import svgJar from 'ember-svg-jar/helpers/svg-jar';

export default class ContactSearch extends Component {
  @service intl;
  @service messaging;

  get searchPlaceholderText() {
    const partOne = this.intl.t('emc.contacts_page.search_prefix');
    const partTwo = this.args.isGroup
      ? this.intl.t('emc.contacts_page.search_placeholder.team_members')
      : this.messaging.searchableContactsText;
    return `${partOne} ${partTwo}`;
  }

  <template>
    <div class="{{styles.component}} search-container" data-test-search-container>
      <label for="contactSearchInput" class="search-label">
        {{t "emc.contacts_page.search_input_label"}}
      </label>
      <TextInput
        class="search-input"
        @id="contactSearchInput"
        @value={{@search}}
        @onInput={{@updateSearch}}
        @placeholder={{this.searchPlaceholderText}}
        data-test-search-input
      />
      {{#if @search}}
        <button
          type="button"
          class="clear-search-button"
          aria-label={{t "emc.contacts_page.clear_search"}}
          {{on "click" @clearSearch}}
          data-test-clear-search-button
        >
          {{svgJar "x-mark"}}
        </button>
      {{/if}}
      <div id="search-help-text" class="visually-hidden">
        {{t "emc.contacts_page.search_help_text"}}
      </div>
    </div>
  </template>
}
